import { h, defineComponent, onUnmounted } from 'vue';
import { IdProps } from '@/ui/helpers/uiHelper';
import { hasFeature, hasPermission, Permissions } from '@/ui/auth/auth';
import { renderForbiddenPage } from '../error/ForbiddenPage';
import ChecklistBuilder from '@/_legacy/views/ChecklistBuilder/ChecklistBuilder.vue';
import { renderResourceTeaserPage } from '@/ui/pages/teasers/ResourceTeaserPage';
import { t } from '@/ui/i18n/i18n';
import { WelcomeFromTemplateBuilder } from '@/ui/pages/WelcomeFromTemplateBuilder';
import { router, useCurrentRoute } from '@/ui/routes';
import { useEntityItemsStore } from '@/stores/conduct/entityItems';

export const ChecklistEditPage = defineComponent<IdProps>({
  name: 'ChecklistEditPage',
  props: ['id'],
  setup(props) {
    if (!hasFeature('inspections')) {
      return renderResourceTeaserPage(t('common.inspections'));
    }

    if (!hasPermission(Permissions.MANAGE_CHECKLISTS)) {
      return renderForbiddenPage;
    }

    const entityItemsStore = useEntityItemsStore();
    const currentRoute = useCurrentRoute();

    onUnmounted(() => entityItemsStore.$reset());

    return function render() {
      //because of these cases with 2 types in properties we should use ts-ignore here
      /**
       * type: [Boolean, String],
       default: false,
       */
      //ts is not compatible with 2+ types in props default. should be only 1
      // @ts-ignore
      return h('div', [h(ChecklistBuilder,
        {
          class: 'legacy pt-6',
          props: {
            resourceId: props.id.toString(),
          },
        }),
      h(WelcomeFromTemplateBuilder, {
        props: {
          active: currentRoute.value.query.signupFromChecklist,
        },
        on: {
          close: () => {
            router.push({ name: currentRoute.value.name! });
          },
        },
      }),
      ]);
    };
  },
});
